import { CoreEntityMap, CoreEntityType } from '#/index'
import { BaseStore } from './baseStore'

export class CodexEntryStore extends BaseStore<CoreEntityMap<CoreEntityType.CodexEntries>> {
  constructor(db: IDBDatabase | null) {
    super(db, CoreEntityType.CodexEntries)
  }
}

export class CodexFieldStore extends BaseStore<CoreEntityMap<CoreEntityType.CodexFields>> {
  constructor(db: IDBDatabase | null) {
    super(db, CoreEntityType.CodexFields)
  }
}

export class CodexCategoryStore extends BaseStore<CoreEntityMap<CoreEntityType.CodexCategories>> {
  constructor(db: IDBDatabase | null) {
    super(db, CoreEntityType.CodexCategories)
  }
}

export class PromptStore extends BaseStore<CoreEntityMap<CoreEntityType.Prompts>> {
  constructor(db: IDBDatabase | null) {
    super(db, CoreEntityType.Prompts)
  }
}

export class PromptDefaultStore extends BaseStore<CoreEntityMap<CoreEntityType.PromptDefaults>> {
  constructor(db: IDBDatabase | null) {
    super(db, CoreEntityType.PromptDefaults)
  }
}

export class PromptPersonaStore extends BaseStore<CoreEntityMap<CoreEntityType.PromptPersonas>> {
  constructor(db: IDBDatabase | null) {
    super(db, CoreEntityType.PromptPersonas)
  }
}

export class PromptPresetStore extends BaseStore<CoreEntityMap<CoreEntityType.PromptPresets>> {
  constructor(db: IDBDatabase | null) {
    super(db, CoreEntityType.PromptPresets)
  }
}

export class ModelBankStore extends BaseStore<CoreEntityMap<CoreEntityType.ModelBanks>> {
  constructor(db: IDBDatabase | null) {
    super(db, CoreEntityType.ModelBanks)
  }
}

export class ModelBankLinkStore extends BaseStore<CoreEntityMap<CoreEntityType.ModelBankLinks>> {
  constructor(db: IDBDatabase | null) {
    super(db, CoreEntityType.ModelBankLinks)
  }
}

export class NovelStore extends BaseStore<CoreEntityMap<CoreEntityType.Novels>> {
  constructor(db: IDBDatabase | null) {
    super(db, CoreEntityType.Novels)
  }
}

export class NovelSceneStore extends BaseStore<CoreEntityMap<CoreEntityType.NovelScenes>> {
  constructor(db: IDBDatabase | null) {
    super(db, CoreEntityType.NovelScenes)
  }
}

export class NovelActStore extends BaseStore<CoreEntityMap<CoreEntityType.NovelActs>> {
  constructor(db: IDBDatabase | null) {
    super(db, CoreEntityType.NovelActs)
  }
}

export class NovelChapterStore extends BaseStore<CoreEntityMap<CoreEntityType.NovelChapters>> {
  constructor(db: IDBDatabase | null) {
    super(db, CoreEntityType.NovelChapters)
  }
}

export class NovelSeriesStore extends BaseStore<CoreEntityMap<CoreEntityType.NovelSeries>> {
  constructor(db: IDBDatabase | null) {
    super(db, CoreEntityType.NovelSeries)
  }
}

export class SnippetStore extends BaseStore<CoreEntityMap<CoreEntityType.Snippets>> {
  constructor(db: IDBDatabase | null) {
    super(db, CoreEntityType.Snippets)
  }
}

export class ChatThreadStore extends BaseStore<CoreEntityMap<CoreEntityType.ChatThreads>> {
  constructor(db: IDBDatabase | null) {
    super(db, CoreEntityType.ChatThreads)
  }
}

export class ChatMessageStore extends BaseStore<CoreEntityMap<CoreEntityType.ChatMessages>> {

  constructor(db: IDBDatabase | null) {
    super(db, CoreEntityType.ChatMessages)
  }
}

export type StoreMap = {
  [CoreEntityType.CodexEntries]: CodexEntryStore;
  [CoreEntityType.CodexFields]: CodexFieldStore;
  [CoreEntityType.CodexCategories]: CodexCategoryStore;
  [CoreEntityType.Prompts]: PromptStore;
  [CoreEntityType.PromptDefaults]: PromptDefaultStore;
  [CoreEntityType.PromptPersonas]: PromptPersonaStore;
  [CoreEntityType.PromptPresets]: PromptPresetStore;
  [CoreEntityType.ModelBanks]: ModelBankStore;
  [CoreEntityType.ModelBankLinks]: ModelBankLinkStore;
  [CoreEntityType.Novels]: NovelStore;
  [CoreEntityType.NovelScenes]: NovelSceneStore;
  [CoreEntityType.NovelActs]: NovelActStore;
  [CoreEntityType.NovelChapters]: NovelChapterStore;
  [CoreEntityType.NovelSeries]: NovelSeriesStore;
  [CoreEntityType.Snippets]: SnippetStore;
  [CoreEntityType.ChatThreads]: ChatThreadStore;
  [CoreEntityType.ChatMessages]: ChatMessageStore;
}